// extracted by mini-css-extract-plugin
export var arrowsContainer = "v3-diaporama-module--arrowsContainer--d8c8f";
export var diaporamaContainer = "v3-diaporama-module--diaporamaContainer--171f7";
export var heading = "v3-diaporama-module--heading--c2944";
export var mainContent = "v3-diaporama-module--mainContent--ac8b5";
export var media = "v3-diaporama-module--media--20dd0";
export var smallMedia = "v3-diaporama-module--smallMedia--9bf36";
export var text = "v3-diaporama-module--text--f56ef";